import { getWithToken, postWithToken } from 'api/network';

function encodeAddress(address) {
  return encodeURIComponent(address).replace(/'/g, '%27');
}

export async function getGoogleImageUrls(fullAddress, width, height, returnNoImage = false) {
  try {
    let signatureRes = await postWithToken('/api/media/images/googleMaps', {
      streetViewUrl: `https://maps.googleapis.com/maps/api/streetview?size=${width}x${height}&sensor=false&location=${encodeAddress(fullAddress)}`,
      streetViewMetadataUrl: `https://maps.googleapis.com/maps/api/streetview/metadata?location=${encodeAddress(fullAddress)}`,
      mapsStaticUrl: `https://maps.googleapis.com/maps/api/staticmap?center=${encodeAddress(fullAddress)}&zoom=21&size=${640}x${640}&maptype=satellite`
    });
    let signedData = await signatureRes.json();
    let rectStreetViewImageString = signedData.streetViewUrl;

    let response = await fetch(signedData.streetViewMetadataUrl); // Using streetview metadata to check if images are available. This is free
    let data = await response.json();
    // Either check if data.status is not 'OK' or equal to 'ZERO_RESULTS'
    // Not equal to 'OK' covers 'ZERO_RESULTS', 'NOT_FOUND' (location is bad), 'OVER_QUERY_LIMIT' (exceeded daily quota or per-second quota to get image), and other errors
    if (data.status !== 'OK') {
      if (!returnNoImage) rectStreetViewImageString = null;
    }
    return {
      streetViewUrl: rectStreetViewImageString,
      mapsStaticUrl: signedData.mapsStaticUrl
    }
  }
  catch (e) {
    console.log(e);
  }
};

export async function getUWPropertyImage(asgPropID, txnOppId, origin) {
  try {
    if (asgPropID) {
      const url = `/api/media/property/images/${asgPropID}?${txnOppId ? `txnOppId=${txnOppId}&` : ''}showListingHistory=true&origin=${origin}`;
      const response = await getWithToken(url);
      const fetchedData = await response.json();
      //console.log('fetchedData', fetchedData);
      // const fetchedImages = fetchedData.length > 0 ? [...fetchedData.map((a)=> a.imageUrl)] : [];
      return fetchedData;
    }
    else {
      return null;
    }
  }
  catch (e) {
    console.log(e);
  }
}